import {
  type AxiosInstance,
  create,
  type InternalAxiosRequestConfig,
} from 'axios'
import { getCookie } from 'cookies-next/client'

import { type PublicGlobalConfig } from '../../global-config'
import { HTTP_HEADER_X_FEATURE_BRANCH } from '../../http'

/**
 * Interceptor that adds feature branch header to home one API requests.
 */
const homeOneAddFeatureBranchHeader = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const featureBranchCookieValue = getCookie(HTTP_HEADER_X_FEATURE_BRANCH)

  if (featureBranchCookieValue) {
    config.headers[HTTP_HEADER_X_FEATURE_BRANCH] = featureBranchCookieValue
  }

  return config
}

/**
 * Build axios instance for home one API clients, with default configs.
 * Instance supposed to be reused so do not put any "per request" logic in here.
 */
export const buildHomeOneApiAxiosInstance = (
  publicGlobalConfig: PublicGlobalConfig,
): AxiosInstance => {
  const instance = create()

  if (publicGlobalConfig.deploymentStage === 'reference') {
    instance.interceptors.request.use(homeOneAddFeatureBranchHeader)
  }

  return instance
}
